import { AnyAccommodationFeatures } from "./search-param";
import { RentalAccommodationFeatures } from "./article-rental";
import { SeasonalAccommodationFeatures } from "./article-seasonal";

type AnyRentalFeatures = RentalAccommodationFeatures | SeasonalAccommodationFeatures;

export const isAnyRentalFeatures =
  (value: AnyAccommodationFeatures): value is AnyRentalFeatures => "maxGuests" in value || "withWIFI" in value || "withTV" in value;
